import { formatDateTimeForDb } from '../../../utils/appTimezone';

export function buildNurseIntakeConsultation({
  response,
  patientSnapshot,
  siteId,
  getPatientDisplayName,
  serviceLine = 'NURSING'
}) {
  const raw = response?.data?.consultation ?? response?.consultation ?? null;
  const visit = response?.data?.visit ?? response?.visit ?? null;
  const member = patientSnapshot?.member;
  const patientName =
    raw?.patient_name ||
    raw?.resolved_patient_name ||
    (patientSnapshot ? getPatientDisplayName(patientSnapshot.kind, member) : 'Patient');

  const consultationId = raw?.id ?? visit?.consultation_id ?? null;
  if (!consultationId) {
    return null;
  }

  const nowIso = formatDateTimeForDb(new Date()) || new Date().toISOString();

  return {
    ...(raw || {}),
    id: consultationId,
    patient_name: patientName,
    member_matricule: raw?.member_matricule ?? member?.matricule ?? null,
    member_company_name: raw?.member_company_name ?? member?.company_name ?? null,
    service_line: raw?.service_line || serviceLine,
    nursing_status:
      raw?.nursing_status || (serviceLine === 'NURSING' ? 'TRIAGE_PENDING' : null),
    status: raw?.status || 'PENDING',
    site_id: raw?.site_id ?? siteId,
    consultation_date: raw?.consultation_date || nowIso
  };
}
